import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { DispatchInfoBox } from "../../components/DOAForecastComponents/DispatchInfoBox";
import { ForecastCollapsibleTable } from "../../components/DOAForecastComponents/ForecastCollapsibleTable";
import { Loading } from "../../components/DOAForecastComponents/Loading";
import { MainContainer } from "../../components/MainContainerComp";
import { DetailsItemType, IAvailableList, IDoaForecastStatsDispatch, IShortageList, IShortageListFilter } from "./DoaForecastStatsData";
import { DoaForecastList, StatusType } from "./DoaForecastStatsModels";
import { greenColorStyle, lastUpdateWrepperStyle, redColorStyle, tabStyle, whiteWrapperStyle } from "./styled";

export interface IDoaForecastStatsProps {
  onRefresh: () => void;
  onLoadList: (list: DoaForecastList, jobId: number, flag545: number) => void;
  onFilterUpdate: (updatedFilter: IShortageListFilter) => void;
  onSelectTab: (_event: React.SyntheticEvent, newValue: number) => void;
  onUpdateCandidateStatuses: (
    jobId: number,
    flag545: number,
    boardCode: string,
    regId: number,
    statusType: StatusType,
    status: boolean
  ) => void;
  loading: boolean,
  submitting?: boolean,
  filter: IShortageListFilter,
  dispatchData: IDoaForecastStatsDispatch | null,
  availableLists: IAvailableList[],
  shortageLists: IShortageList[],
  tab: number,
  isFulfilled?: boolean
}

export const DoaForecastStats: React.FC<IDoaForecastStatsProps> = ({
  onRefresh,
  onLoadList,
  onFilterUpdate,
  onSelectTab,
  onUpdateCandidateStatuses,
  loading,
  submitting,
  filter,
  dispatchData,
  availableLists,
  shortageLists,
  tab,
  isFulfilled
}) => {
  const isDispatchTypeSix = dispatchData?.dispatch === "1745";
  const type = tab ? DetailsItemType.coastwise : DetailsItemType.jobs;

  const dispatchTypeSixDetail = dispatchData?.details &&
    dispatchData.details?.find(detail => detail.type === type);

  const dispatchDetail = isDispatchTypeSix ? dispatchTypeSixDetail : dispatchData?.details[0];
  return (
    <MainContainer>
      {loading && dispatchData &&
        <Loading
          open={loading}
          onClose={() => { }}
          context={dispatchData?.refreshTimeContext} time={dispatchData?.refreshTime}
        />
      }
      {dispatchData && <Box sx={whiteWrapperStyle}>
        <Typography
          component={'div'} 
          variant='container' 
          data-automation="data-container"
        >
          <DispatchInfoBox
            refreshContext={dispatchData?.refreshTimeContext}
            refreshTime={dispatchData?.refreshTime}
            date={dispatchData.dispatchDate}
            dispatchDescription={dispatchData.dispatchDescription}
            availabilityStatus={dispatchData?.availabilityStatus}
            dispatchStatus={dispatchData?.physicalDispatchStatus}
            rows={[
              ['Jobs Required', <Typography component='span' sx={redColorStyle}>{dispatchData?.jobRequired}</Typography>],
              ['Total Employees Using DOA System', <Typography component='span' sx={greenColorStyle}>{dispatchData?.totalEmployees}</Typography>],
              ['Total Employees Not Eligible', dispatchData?.totalEmployeesNotEligible],
              ['Total Employees Eligible', dispatchData?.totalEmployeesEligible]
            ]}
          />
        </Typography>
        <Typography 
          sx={{ mt: 2 }}
          component={'div'} 
          variant='container' 
          data-automation="data-container"
        >
          {
            isDispatchTypeSix && <Tabs
              sx={tabStyle}
              value={tab}
              onChange={onSelectTab}
            >
              <Tab
                disableRipple
                sx={tabStyle}
                label="Squamish"
              />
              <Tab
                disableRipple
                sx={tabStyle}
                label="Coastwise"
              />
            </Tabs>
          }
          <>{dispatchDetail ?
            <ForecastCollapsibleTable
              isDoaAdmin={true}
              isFulfilled={isFulfilled}
              filter={filter}
              availableLists={availableLists}
              shortageLists={shortageLists}
              loading={loading}
              submitting={submitting}
              onLoadList={onLoadList}
              onFilterUpdate={onFilterUpdate}
              onUpdateCandidateStatuses={onUpdateCandidateStatuses}
              detail={{
                ...dispatchDetail,
                jobStats: dispatchDetail.jobStats.map(({
                  jobDescription,
                  jobsRequired,
                  totalAvailable,
                  matchedAvailable,
                  tsc,
                  short,
                  jobId,
                  flag545,
                  jobDetails
                }) =>
                ({
                  jobDescription,
                  jobsRequired,
                  totalAvailable,
                  matchedAvailable,
                  tsc,
                  short,
                  jobId,
                  flag545,
                  jobDetails
                }))
              }}
            /> : 
            <Typography 
              sx={{ 
                display: 'flex',
                minHeight: '200px',
                justifyContent: 'center',
                alignItems: 'center'
              }} 
              data-automation="no-data-lbl"
            >
              No data
            </Typography>
          }</>
        </Typography>
        <Box sx={lastUpdateWrepperStyle}>
          <Box sx={{ mr: 4 }}>
            <Typography data-automation="last-update">Last update of job requirements for this shift: {dispatchData?.lastUpdate}</Typography>
            <Typography data-automation="last-refresh">Last refresh on this screen: {dispatchData?.lastRefresh}</Typography>
          </Box>
          <Button
            variant="contained"
            size="medium"
            onClick={onRefresh}
            data-automation="refresh-button"
            sx={{ height: 'fit-content' }}
          >
            Refresh
          </Button>
        </Box>
      </Box>}
    </MainContainer>
  )
}